import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://43423mh.com${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="w-full">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <ol className="flex items-center flex-wrap gap-1.5 text-xs">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}